
  import { mapState } from 'vuex'
  export default {
    name: 'ProfileDropdown',
    computed: {
      ...mapState({
        player: state => state.player.player
      }),
      menus() {
        return [
          { title: 'myProfile', link: '/player/profile' },
          { title: 'cashier', link: '/cashier' },
          { title: 'gameHistory', link: '/history/game' },
          { title: 'messages', link: '/messages' }
        ]
      }
    }
  }
